<template>
    <div class="antialiased">

        <Sidebar/>

        <div class="page">

            <Header hint="Cari" :enabled="false"/>

            <div class="content">
                <div class="container">
                    <!-- Page title -->
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">
                                    Laporan Tracking Effective Call
                                </h2>
                            </div>

                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto px-0">
                
                                    </div>

                                    <div class="col-auto">
                                        <button class="btn btn-white" v-html="ic('filter')+' Filter'" @click="_filter"> </button>
                                    </div>
                                    <div class="col-auto" v-if="!loading && data.length > 0">
                                        <button class="btn btn-primary" v-html="ic('download')+' Download PDF'" @click="_createPdf"> </button>
                                    </div>
                                    <div class="col-auto" v-if="!loading && data.length > 0">
                                        <button class="btn btn-primary" v-html="ic('download')+' Download Excel'" @click="_createExcel"> </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

                    <Nodata v-if="!loading && data.length == 0 && isFilter"/>

                    <div class="box" v-if="!loading && data.length > 0">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter table-hover card-table table-striped table-control">
                                    <thead>
                                        <tr class="text-muted">
                                            <th>No</th>
                                            <th>Nama Supervisor</th>
                                            <th>Nama Tim</th>
                                            <th v-for="(row, i) in weeks" :key="i">Week {{ row.week }}</th>
                                            <th>Average Week</th>
                                            <th>Average Day</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, i) in data" :key="i">
                                            <td>{{ i + 1 }}</td>
                                            <td>{{ row.supervisor }}</td>
                                            <td>{{ row.nama_tim }}</td>
                                            <td v-for="(value, key) in row.detail" :key="key">{{ value }}</td>
                                            <td>{{  row.average | roundToDecimal(1) }}</td>
                                            <td>{{  row.total / (days - dataFilter.jumlah_libur) | roundToDecimal(1) }}</td>
                                            <td>{{  row.total }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

      </div>

      <FormFilter
          :config.sync="filter.config"
          :initData="filter.data" :dismiss.sync="filter.dismiss"
          :isSubmit.sync="filter.isSubmit"
          @submit="filter.action"
      />

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

import jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from 'xlsx';

export default {
    name: "LaporanEC",
    components: { FormFilter },

    filters: {
        roundToDecimal(value, decimalPlaces) {
            return value.toFixed(decimalPlaces);
        }
    },

    data() {
        return {
            auth: {},

            filter: {
                config: {
                    view: false,
                    title: null
                },
                data: null,
                isSubmit: false,
                action: () => {}
            },

            loading: false,
            isFilter: false,
            data: [],
            weeks: [],
            days: 0,

            dataFilter: {
                id_principal: [],
                id_brand: [],
                id_supervisor: [],
                id_tim: [],
                start_week: 0,
                end_week: 0,
                start_year: "",
                end_year: "",
                jumlah_libur: 0,
            },

            params: {},
        };
    },

    mixins: [helper],

    methods: {

        _get() {
            this.loading = true,

            this.params = {
                id_principal: this.dataFilter.id_principal,
                id_brand: this.dataFilter.id_brand,
                id_supervisor: this.dataFilter.id_supervisor,
                id_tim: this.dataFilter.id_tim,
                start_week: this.dataFilter.start_week,
                end_week: this.dataFilter.end_week,
                start_year: this.dataFilter.start_year,
                end_year: this.dataFilter.end_year
            }

            this.axios.get("report/tracking/effective_call", {params: this.params}).then( res => {
                this.loading = false;

                this.data = [];
                if (res.data.length != 0) {
                    this.data = res.data.data
                    this.weeks = res.data.weeks
                    this.days = res.data.total_days
                }
            }).catch( err => {
                this.loading = false;
                this.onError(err)
            });
        },

        _filter() {
            this.filter.config = {
                view: true,
                title: "Filter"
            }

            this.filter.action = (formData) => {
                this.isFilter = true
                
                for (const key in formData) {
                    this.dataFilter[key] = formData[key]
                }

                this._get()
            }
        },

        _createPdf(){
            let doc = new jsPDF('landscape'), user = JSON.parse(localStorage.user);
            let styles = { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 }

            // title
            doc.autoTable({
                theme: 'plain',
                styles: { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 },
                margin: { top: 10, left: 10, right: 10 },
                columnStyles: { 1: { halign: 'center', fontSize: 18 } },

                head: [['Laporan Effective Call', '']],

                body: [
                ['Laporan Effective Call', { content: "Laporan Effective Call", rowSpan: 2, styles: { halign: 'right' } }],
                ['',],
                ['Data Received Week ' + this.dataFilter.start_week + " / Year " + this.dataFilter.start_year + ' until ' + this.dataFilter.end_week + " / Year " + this.dataFilter.end_year,],
                ],
            })

            let headers = ['Nama Supervisor', 'Nama Tim'];
            for(let i = 0; i < this.weeks.length; i++) {
                headers.push("Week " + this.weeks[i].week)
            }
            headers.push("Average Week")
            headers.push("Average Day")
            headers.push("Total")
            let header = [headers], temp = [];

            for(let i = 0; i < this.data.length; i++){
                let data = this.data[i];
                temp.push(data.supervisor)
                temp.push(data.nama_tim)
                for(let j = 0; j < this.weeks.length; j++) {
                    let detail = data.detail;
                    let item = detail["week_" + this.weeks[j].week]
                    temp.push(item);
                }
                temp.push((data.average).toFixed(1))
                temp.push((data.total / (this.days - this.dataFilter.jumlah_libur)).toFixed(1))
                temp.push(data.total)
                header.push(temp)
                temp = [];
            }

            styles['cellPadding'] = 2;


            doc.autoTable({ // body
                theme: 'grid', styles: styles, margin: { top: 10, left: 10, right: 10 },
                body: header,
            })

            this.pdfDownload([ doc.output() ])
        },

        _createExcel() {
            const workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.json_to_sheet([]);

            const content = [];
            content.push(['Laporan Effective Call', '', '']);
            content.push(['', '', '']);
            content.push(['Data Received Week ' + this.dataFilter.start_week + " / Year " + this.dataFilter.start_year + ' until ' + this.dataFilter.end_week + " / Year " + this.dataFilter.end_year, '', '']);
            content.push(['', '', '']);

            const headers = ['Nama Supervisor', 'Nama Tim'];
            for(let i = 0; i < this.weeks.length; i++) {
                headers.push("Week " + this.weeks[i].week)
            }
            headers.push("Average Week")
            headers.push("Average Day")
            headers.push("Total")
            content.push(headers)

            for(let i = 0; i < this.data.length; i++){
                let data = this.data[i];
                let cnt = [data.supervisor, data.nama_tim];
                for(let j = 0; j < this.weeks.length; j++) {
                    let detail = data.detail;
                    let item = detail["week_" + this.weeks[j].week]
                    cnt.push(item);
                }
                cnt.push(data.average)
                cnt.push(data.total / (this.days - this.dataFilter.jumlah_libur))
                cnt.push(data.total)
                content.push(cnt)
            }

            XLSX.utils.sheet_add_aoa(worksheet, content);
    
            const merge = [
                {
                s: { r: 0, c: 0 },
                e: { r: 0, c: 2 }
                },
                {
                s: { r: 2, c: 0 },
                e: { r: 2, c: 4 }
                }
            ]

            worksheet['!merges'] = merge;

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Effective Call');

            XLSX.writeFile(workbook, 'laporan_tracking_ec_' + this.dataFilter.start_week + '_sampai_' + this.dataFilter.end_week + '.xlsx');
        },

    },

    mounted(){
        this.auth = JSON.parse(localStorage.user)
    },
}
</script>